import React from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { func } from 'prop-types';
import { styled, Flex } from '@goodrx/matisse';

import { CdnImage } from 'app/components/CdnImage';
import { SectionTitle } from 'app/components/SectionTitle';
import { Breakpoints } from 'app/config/constants';

const AppLink = styled.a`
  margin: 0 8px;
  display: block;
`;

const Container = styled(Flex)`
  width: 100%;
  flex-direction: column;
  border-top: 1px solid ${(p) => p.theme.colors.greyLight};
  padding-top: 24px;

  @media (min-width: ${Breakpoints.md}px) {
    flex-direction: row;
  }
`;

const Section = styled(Flex)`
  flex: 1;
  padding: 40px;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${Breakpoints.md}px) {
    &:last-child:not(:first-child) {
      border-left: 1px solid ${(p) => p.theme.colors.greyLight};
    }
  }
`;

const Blurb = styled.span`
  display: block;
  max-width: 300px;
  text-align: center;
`;

interface HelpFooterProps {
  renderHelpContent?: any;
}

function HelpFooter({ renderHelpContent }: HelpFooterProps) {
  const [toggleChat] = useSynapse(({ chat }) => [chat.toggleChat]);

  return (
    <Container>
      <Section>
        <CdnImage path="icons/chat-large.png" style={{ height: 45 }} />
        <SectionTitle fontSize={18}>We’re here to help!</SectionTitle>

        {typeof renderHelpContent === 'function' ? (
          renderHelpContent()
        ) : (
          <Blurb>
            If you have any questions or concerns, <br />
            <span
              style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}
              onKeyPress={toggleChat}
              role="presentation"
              onClick={toggleChat}>
              send us a message
            </span>{' '}
            or visit our{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://help.heydoctor.com"
              style={{ color: 'inherit', textDecoration: 'underline' }}>
              help center
            </a>
            .
          </Blurb>
        )}
      </Section>

      <Section>
        <SectionTitle fontSize={18}>Download Our App</SectionTitle>
        <Blurb>Check visit status, doctor messages, or start a new visit with our app.</Blurb>

        <Flex justifyContent="center" mt={3}>
          <AppLink target="_blank" rel="noopener noreferrer" href="https://app.appsflyer.com/id1269448452?pid=Organic">
            <CdnImage path="images/appstore-dark.png" style={{ height: 45 }} />
          </AppLink>

          <AppLink
            target="_blank"
            rel="noopener noreferrer"
            href="https://app.appsflyer.com/co.heydoctor.android?pid=Organic">
            <CdnImage path="images/playstore-dark.png" style={{ height: 45 }} />
          </AppLink>
        </Flex>
      </Section>
    </Container>
  );
}

HelpFooter.propTypes = {
  renderHelpContent: func,
};

export default HelpFooter;
